class HomeSlider extends Component {
	constructor(el) {
		super(el);
		this.swiperEl = this.$find('[data-swiper]');
		this.swiper = null;
		this.swiperEl && this.constructSwiper();
	}

	constructSwiper() {
		this.swiper = new Swiper(this.swiperEl, {
			watchOverflow: true,
			speed:500,
			pagination: {
				el: ".swiper-pagination",
				type: "progressbar",
			  },
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			effect: 'fade',
			fadeEffect: {
			  crossFade: false
			},
		});
	}
}
